import React from 'react';
import { motion } from 'framer-motion';

const TermsOfService = () => {
  return (
    <div className="bg-brand-light min-h-screen py-20 px-4">
      <div className="max-w-3xl mx-auto bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-gray-100">
        <motion.h1 
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-3xl font-serif font-bold text-brand-dark mb-8 border-b pb-4"
        >
          Terms of Service
        </motion.h1>
        
        <div className="prose prose-brand text-gray-700 space-y-6">
          <p className="text-sm text-gray-500 italic">Last Updated: {new Date().toLocaleDateString()}</p>
          
          <section>
            <h2 className="text-xl font-bold text-brand-green mb-2">1. Acceptance of Terms</h2>
            <p>By accessing Golden Compass Travel Guides, provided by <strong>WinWhen Consulting Corp.</strong>, you agree to be bound by these terms. If you do not agree, please do not use this site.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-brand-green mb-2">2. Use of Content</h2>
            <p>All content provided on this site is for informational purposes only. While we strive for accuracy, WinWhen Consulting Corp. is not liable for errors or omissions in travel guidance or external links.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-brand-green mb-2">3. Intellectual Property</h2>
            <p>The logos, text, and curated guides are the property of WinWhen Consulting Corp. and may not be reproduced without written permission.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-brand-green mb-2">4. Disclaimers</h2>
            <p>Travel involves inherent risks. Users are responsible for their own safety and travel decisions. We provide links to third-party tools (like calculators and businesses) as resources, but we do not control their terms or operations.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;